import React from 'react';
import Background from './Background';
import Content from './Content';

const Body = ({ Background: backgroundData, Content: contentItems, BodyStyle }) => {
  let containerClasses = ['position-relative', 'w-100'];

  const itemHasVisualBackground = (item) => {
    return item.BackgroundType === 'Media' || (item.BackgroundType === 'Color') ||  !!item.BackgroundColorHexCode;

  };

  if (BodyStyle === 'style1'){
    containerClasses.push('row', 'gy-3');
  } else if (BodyStyle === 'style2') {
    containerClasses.push('row', 'g-sm-3', 'row-cols-1', 'row-cols-md-2', 'row-cols-lg-3');
  } else if (BodyStyle === 'style3') {
    // containerClasses.push('d-flex', 'flex-column', 'align-items-center', 'g-4');
    containerClasses.push('row', 'gy-3');
  } else if (BodyStyle === 'style4') {
    // Für Style 4 benötigen wir nur 'row' und 'g-4' auf dem Container.
    // Die Spaltenbreiten werden PRO ITEM dynamisch gesetzt.
    containerClasses.push('row', 'gy-3');
  } else {
    // do nothing
  }

  return (
    <main className="position-relative bg-white px-0 shadow-sm d-flex flex-column align-items-start justify-content-start overflow-hidden h-100">
      <Background {...backgroundData} />

       <div className={`${containerClasses.join(' ')} gx-0`}>
        {contentItems && contentItems.length > 0 ? (
          contentItems.map((item) => {
            const hasBackground = itemHasVisualBackground(item);
            let itemColClass = '';

            if (BodyStyle === 'style2') {
              itemColClass = 'col'; // Nutzt row-cols-* auf dem Elternelement
            } else if (BodyStyle === 'style4') {
                if (hasBackground) {
                  // Wenn Hintergrund: volle Breite (3/3) auf allen Bildschirmen
                  itemColClass = 'col-12';
                } else {
                  // Wenn KEIN Hintergrund:
                  // Mobile (xs, sm): volle Breite (stackt)
                  // Medium (md): halbe Breite (2 pro Reihe)
                  // Large (lg) und größer: Drittel-Breite (3 pro Reihe)
                  itemColClass = 'col-12 col-md-6 col-lg-4';
                }
            } else {
              itemColClass = 'col-12'; // Standard: volle Breite für andere Styles
            }

            return (
              <div key={item.id}  className={`${itemColClass} px-0`}>
                <Content {...item} BodyStyle={BodyStyle} />
              </div>
            );
          })
        ) : (
          <p className="text-secondary text-center">Kein Inhalt für diesen Hauptbereich vorhanden.</p>
        )}
      </div>
    </main>
  );
};

export default Body;